export default __webpack_public_path__ + "static/media/sponsor-icon.cd723993.webp";